import { render, staticRenderFns } from "./monthdetail.vue?vue&type=template&id=428da50a"
import script from "./monthdetail.vue?vue&type=script&lang=js"
export * from "./monthdetail.vue?vue&type=script&lang=js"
import style0 from "./monthdetail.vue?vue&type=style&index=0&id=428da50a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports